import Vue from 'vue';
import VueI18n from 'vue-i18n';
import englishMessages from './locales/en';
import { persistLanguage } from './language';
import englishExtensions from './englishExtensions.generated';

Vue.use(VueI18n);

const mergeDeep = (target, source) => {
  Object.keys(source || {}).forEach(key => {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      target[key] = mergeDeep({ ...(target[key] || {}) }, source[key]);
    } else target[key] = source[key];
  });
  return target;
};

// Only the generated English message tree is imported into the production
// bundle. Legacy locale files remain outside the runtime dependency graph.
const english = mergeDeep({ ...englishMessages }, englishExtensions);

const initialLanguage = persistLanguage('en');

export default new VueI18n({
  locale: initialLanguage,
  fallbackLocale: 'en',
  messages: { en: english },
  silentTranslationWarn: true
});
